import { render, staticRenderFns } from "./courseVideoDetais.vue?vue&type=template&id=a8b7179e"
import script from "./courseVideoDetais.vue?vue&type=script&lang=js"
export * from "./courseVideoDetais.vue?vue&type=script&lang=js"
import style0 from "./courseVideoDetais.vue?vue&type=style&index=0&id=a8b7179e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports